export class StudentCourseEditResponseModel {
	registration_id: number;
	message: string;
	access_grant_successful?: boolean;
	rebuild_acknowledgement_required?: boolean;
}
